import { request } from '@/shared/api/request'

export const sendSms = ({ data }) => request({ url: `contract/sl/approve/sms`, method: 'POST', data: data })
